import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { displayIcon } from "variables/icons";

import { 
    getChatList
} from "../../../../redux/chat/chatState";

const ChatConversationList = ({...props}) => {

    const dispatch = useDispatch();
    const conversations = useSelector((state) => state.chat.chatList.items);
    
    useEffect(() => {
            dispatch(getChatList());
    },[dispatch]);

    return (
        <>
            <div className={`border rounded-md h-full bg-white shadow-sm border-slate-200`}>
                <div className="flex flex-col gap-2 p-3">
                    {conversations.map((conversation) => (
                        <div key={conversation.ccv_id} className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 cursor-pointer">
                            {conversation.ccv_announcement_id ? (
                                displayIcon(conversation.announcement.ann_icon, "w-5 h-5 text-gray-800")
                            ) : (
                                displayIcon('MessageSquare', "w-5 h-5 text-gray-800")
                            )}
                            <div className="flex flex-col">
                                <span className="text-gray-800">{conversation.ccv_name}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default ChatConversationList;
